module.exports = __webpack_public_path__ + "static/media/avatar.b3881528.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/common/brand/avatar.svg
// module id = 526
// module chunks = 0